import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClientDetailAssessmentsPage, ClientDetailJourneyPage } from '@sondermind/features/provider-facing/client-detail';
import { ClientNotesContainerComponent } from '@sondermind/member/pages/client-notes-container/client-notes-container.component';
import { CurrentClientsListPage } from '@sondermind/member/pages/current-clients-list/current-clients-list.component';
import { MatchClientsListPage } from '@sondermind/member/pages/match-clients-list/match-clients-list.component';
import { ClientPrescriptionsInfoPage } from '@sondermind/member/pages/client-detail-prescriptions-info/client-detail-prescriptions-info.component';

import { ClientDetailPage } from '../../pages/client-detail/client-detail.component';
import { ClientDetailAssessmentTypePage } from '../../pages/client-detail-assessment-type/client-detail-assessment-type.component';
import { ClientDetailContactInfoPage } from '../../pages/client-detail-contact-info/client-detail-contact-info.component';
import { ClientDetailDocumentsPage } from '../../pages/client-detail-documents/client-detail-documents.component';
import { ClientDetailPaymentInfoPage } from '../../pages/client-detail-payment-info/client-detail-payment-info.component';
import { ClientDetailsSmartNotesComponent } from '../../components/client-detail-smart-notes/client-detail-smart-notes.component';
import { ClientDetailTreatmentplanComponent } from '../../components/client-detail-treatmentplan/client-detail-treatmentplan.component';

import { ClientsAppComponent } from './clients-app.component';

const routes: Routes = [
  {
    path: '',
    component: ClientsAppComponent,
    children: [

      // lists
      { path: '', redirectTo: 'current', pathMatch: 'full' },
      { path: 'current', component: CurrentClientsListPage },
      { path: 'matches', component: MatchClientsListPage },

      // filter to only new clients
      { path: 'new', redirectTo: 'matches', pathMatch: 'full' },

      // details
      {
        path: ':id',
        component: ClientDetailPage,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'client_notes'
          },
          {
            path: 'client_journey',
            component: ClientDetailJourneyPage
          },
          {
            path: 'client_notes',
            data: {},
            children: [
              { path: '', component: ClientNotesContainerComponent },
            ]
          },
          {
            path: 'smart_notes',
            data: {},
            children: [
              { path: '', component: ClientDetailsSmartNotesComponent },
              { path: ':note_id', component: ClientDetailsSmartNotesComponent }
            ]
          },
          {
            path: 'payment_info',
            component: ClientDetailPaymentInfoPage
          },
          {
            path: 'contact_info',
            component: ClientDetailContactInfoPage
          },
          {
            path: 'treatment_plan',
            data: {},
            children: [
              { path: '', component: ClientDetailTreatmentplanComponent },
              { path: ':note_id', component: ClientDetailTreatmentplanComponent }
            ]
          },
          {
            path: 'assessments',
            component: ClientDetailAssessmentsPage
          },
          {
            path: 'documents',
            component: ClientDetailDocumentsPage
          },
          {
            path: 'prescriptions_info',
            component: ClientPrescriptionsInfoPage
          },
          // The page self-loads from the patient store; only `type` is needed in the URL.
          {
            path: 'assessments/:type',
            component: ClientDetailAssessmentTypePage
          },
          {
            path: 'chat',
            redirectTo: '/dashboard?openChat=true',
            // TODO: PE-26982 - remove when email link changes and longer contains outlet
            outlet: 'nonClinicalChatModal',
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
